import { createSelector } from "reselect";
import translateObject from "../../utilities/translateObject";
import getRegion from "./getRegion";
import { getProductsAndVideos } from "../shared/getProductsAndVideos";

const stateWishlist = state => state.wishlist.products;

const getProducts = createSelector(
  [getRegion, getProductsAndVideos, stateWishlist],
  (region, products, wishlist) => {
    if (region) {
      return products.map(product => {
        return Object.assign({}, product, {
          name: translateObject(product.name, region.language),
          url: translateObject(product.url, region.language),
          video: translateObject(product.video, region.language),
          wishlisted: wishlist.includes(product.sku)
        });
      });
    }
    return products;
  }
);

const getProduct = sku => {
  return createSelector([getProducts], products => {
    return products.find(product => product.sku === sku);
  });
};

export { getProducts, getProduct };
